import { useEffect, useState } from "react";
import { ProSidebar, Menu, MenuItem, SubMenu } from "react-pro-sidebar";
import { Box, Popover, Button } from "@mui/material";
import { Link } from "react-router-dom";
import "react-pro-sidebar/dist/css/styles.css";
import { colors } from "../../theme";
import HomeOutlinedIcon from "@mui/icons-material/HomeOutlined";
import ShowChartIcon from "@mui/icons-material/ShowChart";
import PeopleAltIcon from "@mui/icons-material/PeopleAlt";
import ManageAccountsIcon from "@mui/icons-material/ManageAccounts";
import SwitchAccountIcon from "@mui/icons-material/SwitchAccount";
import ReportIcon from "@mui/icons-material/Report";
import CampaignIcon from "@mui/icons-material/Campaign";
import GraphicEqIcon from "@mui/icons-material/GraphicEq";
import RadarIcon from "@mui/icons-material/Radar";
import API from "../../api/index";
import ViewTimelineIcon from "@mui/icons-material/ViewTimeline";
import LocalActivityIcon from "@mui/icons-material/LocalActivity";
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
import Grid from "@mui/material/Grid";

const Item = ({ title, to, icon, selected, setSelected }) => {
  return (
    <MenuItem
      active={selected === title}
      style={{
        color: colors.grey[100],
      }}
      onClick={() => {
        window.sessionStorage.setItem("selectedTab", title);
        setSelected(title);
      }}
      icon={icon}
    >
      <Link to={to} />
    </MenuItem>
  );
};

const SidebarR = ({ customerName }) => {
  const [anchorEl] = useState(null);
  const [isCollapsed] = useState(false);

  const [selected, setSelected] = useState(() => {
    const saved = window.sessionStorage.getItem("selectedTab");
    return saved !== null ? saved : "Dashboard";
  });

  const [, setImage] = useState();
  const [, setCompanyName] = useState();
  const [, setImageType] = useState();
  const [, setNome] = useState();
  const [, setCognome] = useState();
  const [submenuOpen, setSubmenuOpen] = useState({
    customersStat: false,
    customer: false,
  });

  const [openPopovers, setOpenPopovers] = useState({
    customersStat: false,
    customer: false,
  });

  const toggleSubmenu = (submenu) => {
    setSubmenuOpen((prevState) => ({
      ...prevState,
      [submenu]: !prevState[submenu],
    }));
    setOpenPopovers((prevOpenPopovers) => ({
      ...prevOpenPopovers,
      [submenu]: !prevOpenPopovers[submenu],
    }));
  };

  const determineParentSubmenu = (item) => {
    if (CustomersStat.includes(item)) {
      return "customersStat";
    } else if (Customer.includes(item)) {
      return "customer";
    }
    return null;
  };

  useEffect(() => {
    const parentSubmenu = determineParentSubmenu(selected);
    if (parentSubmenu === "customer") {
      setSubmenuOpen({
        customersStat: true,
        customer: true,
      });
    } else {
      setSubmenuOpen((prevState) => ({
        ...prevState,
        [parentSubmenu]: true,
      }));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps -- determineParentSubmenu is a plain function recreated every render; adding it (and selected) would re-run this mount-only effect every render
  }, []);

  const Customer = [
    "Critical",
    "Alert",
    "Movements",
    "Internal Detection",
    "Threat Intelligence",
  ];
  const CustomersStat = ["Customers", "NFR"];

  useEffect(() => {
    const fetchData = () => {
      API.getDataUsers()
        .then((result) => {
          setImage(result.data.profileImage);
          setCompanyName(result.data.ragioneSociale);
          setImageType(result.data.imageType);
          setNome(result.data.nome);
          setCognome(result.data.cognome);
        })
        .catch((error) => {
          console.error('[fetchData] error:', error);
        });
    };

    fetchData();
  });

  // Salva lo stato nel localStorage ogni volta che cambia
  useEffect(() => {
    window.sessionStorage.setItem("selectedTab", selected);
  }, [selected]);

  return (
    <Box
      className="bottom-0 flex justify-between z-10"
      display="flex"
      alignItems="center"
      justifyContent="space-between"
      sx={{
        position: "fixed",
        left: 0,
        zIndex: 1000,
        height: "50px",
        width: "100%",

        "& .pro-sidebar" : {
          boxShadow: "0px 0px 10px #eaeaea" // Corretto l'ombra
        },
        "& .pro-sidebar-inner": {
          backgroundColor: "#1e1e1e !important",
         //borderTop: "solid 1px #eaeaea",
        },
        "& .pro-icon-wrapper": {
          backgroundColor: "transparent !important",
        },
        "& .pro-inner-item": {
          padding: "5px 10px 5px 10px !important",
        },
        "& .pro-inner-item:hover": {
          color: "#73ccd7 !important",
        },
        "& .pro-menu-item.active": {
          color: "#52a0a6 !important",
        },
        // "& .pro-sidebar-layout": {
        //   overflow: "hidden !important",
        // }
      }}
    >
      <ProSidebar collapsed={isCollapsed} width={"100%"}>
        <Menu iconShape="square">
          <Grid container className="sidebarMobile" spacing={1}>
            <Item
              title="Dashboard"
              to="/reseller/home/"
              icon={<HomeOutlinedIcon sx={{ width: "20px !important", height: "auto" }} />}
              selected={selected}
              setSelected={setSelected}
            />
            <Item
              title="All Highlights"
              to="/reseller/highlights/"
              icon={<ShowChartIcon sx={{ width: "20px", height: "auto" }} />}
              selected={selected}
              setSelected={setSelected}
            />
            <SubMenu
              icon={<SwitchAccountIcon sx={{ width: "20px", height: "auto" }} />}
              open={submenuOpen.customersStat}
              onClick={(e) => toggleSubmenu("customersStat", e)}
            >
              <Popover
                className="popoverNavBar"
                id="customersStat"
                open={openPopovers.customersStat}
                anchorEl={anchorEl}
                sx={{ marginLeft: "5vh" }} // Adjust as needed
                anchorOrigin={{
                  vertical: "bottom",
                  horizontal: "center",
                }}
                transformOrigin={{
                  vertical: "top",
                  horizontal: "center",
                }}
              >
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    background: `#1e1e1e !important`,
                  }}
                >
                  <Button
                  sx={{marginBottom:"5%", marginTop:"5%"}}
                    onClick={() => {
                      window.location.href = "/reseller/myC/customers";
                    }}
                  >
                    <Item
                      title="Customers"
                      to="/reseller/myC/customers"
                      selected={selected}
                      setSelected={setSelected}
                      icon={<PeopleAltIcon />}
                    />
                  </Button>
                  <Button
                  sx={{marginBottom:"5%"}}
                    onClick={() => {
                      window.location.href = "/reseller/myC/nfr";
                    }}
                  >
                    <Item
                      title="NFR"
                      to="/reseller/myC/nfr"
                      selected={selected}
                      setSelected={setSelected}
                      icon={<ViewTimelineIcon />}
                    />
                  </Button>


                  {customerName && (
                    <SubMenu
                    className="customerSelected"
                    sx={{
                      width: "20px",
                      height: "auto",
                      flexDirection: "column",
                      // esempio di utilizzo dei breakpoints
                      ...(theme) => ({
                        [theme.breakpoints.down('xs')]: {
                          title: '',
                        },
                        [theme.breakpoints.up('md')]: {
                          title: customerName,
                        },
                      }),
                    }}
                    icon={<ManageAccountsIcon />}
                    open={submenuOpen.customer}
                    onClick={(e) => {
                      e.stopPropagation();
                      toggleSubmenu("customer", e);
                    }}
                  >
                      <Popover
                        className="popoverNavBar"
                        id="customer"
                        open={openPopovers.customer}
                        anchorEl={anchorEl}
                        sx={{ marginLeft: "5vh" }} // Adjust as needed
                        anchorOrigin={{
                          vertical: "bottom",
                          horizontal: "center",
                        }}
                        transformOrigin={{
                          vertical: "top",
                          horizontal: "center",
                        }}
                      >
                        <Box
                          sx={{
                            display: "flex",
                            flexDirection: "column",
                            background: `#1e1e1e !important`,
                          }}
                        >
                          <Button
                          sx={{marginBottom:"5%", marginTop:"5%"}}
                            onClick={() => {
                              window.location.href = "/reseller/myC/highlights";
                            }}
                          >
                            <Item
                              title="Highlights"
                              to="/reseller/myC/highlights"
                              selected={selected}
                              setSelected={setSelected}
                              icon={<ShowChartIcon />}
                            />
                          </Button>
                          <Button
                          sx={{marginBottom:"5%", marginTop:"5%"}}
                            onClick={() => {
                              window.location.href = "/reseller/myC/highlights";
                            }}
                          >
                            <Item
                              title="Critical"
                              to="/reseller/myC/critical"
                              selected={selected}
                              setSelected={setSelected}
                              icon={<ReportIcon />}
                            /></Button>
                          <Button
                          sx={{marginBottom:"5%", marginTop:"5%"}}
                            onClick={() => {
                              window.location.href = "/reseller/myC/highlights";
                            }}
                          >
                            <Item
                              title="Movements"
                              to="/reseller/myC/movements"
                              selected={selected}
                              setSelected={setSelected}
                              icon={<GraphicEqIcon />}
                            /></Button>
                          <Button
                          sx={{marginBottom:"5%", marginTop:"5%"}}
                            onClick={() => {
                              window.location.href = "/reseller/myC/highlights";
                            }}
                          >
                            <Item
                              title="Alert"
                              to="/reseller/myC/alert"
                              selected={selected}
                              setSelected={setSelected}
                              icon={<CampaignIcon />}
                            /></Button>
                          <Button
                          sx={{marginBottom:"5%", marginTop:"5%"}}
                            onClick={() => {
                              window.location.href = "/reseller/myC/highlights";
                            }}
                          >
                            <Item
                              title="Internal Detection"
                              to="/reseller/myC/internal-detection"
                              selected={selected}
                              setSelected={setSelected}
                              icon={<RadarIcon />}
                            /></Button>
                        </Box>
                      </Popover>
                    </SubMenu>
                  )}
                </Box>
              </Popover>

            </SubMenu>
            <Item
              title="Tickets"
              to="/reseller/tickets"
              selected={selected}
              setSelected={setSelected}
              icon={<LocalActivityIcon sx={{ width: "20px", height: "auto" }} />}
            />
            <Item
              title="Material"
              to="/reseller/material"
              selected={selected}
              setSelected={setSelected}
              icon={<PictureAsPdfIcon sx={{ width: "20px", height: "auto" }} />}
            />
          </Grid>
        </Menu>
      </ProSidebar>
    </Box>
  );
};

export default SidebarR;
